import type { Transition } from "framer-motion";

export const DURATION = {
    fast: 0.15,
    base: 0.25,
    slow: 0.4
} as const;

export const EASE = {
    out: [0.22, 1, 0.36, 1],
    inOut: [0.65, 0, 0.35, 1],
    sheet: [0.32, 0.72, 0, 1]
} as const;

export const SPRING: Record<"pop" | "bouncy" | "soft", Transition> = {
    pop: { type: "spring", stiffness: 500, damping: 30, mass: 0.8 },
    bouncy: { type: "spring", stiffness: 600, damping: 18 },
    soft: { type: "spring", stiffness: 260, damping: 24 }
};

export const STAGGER = {
    items: 0.06,
    sections: 0.1
} as const;
